import { Button, Modal, Typography } from '@mui/joy';

import AngleUpIcon from '@/assets/icons/button-decorators/angle-up.svg?react';
import WelcomeIllustration from '@/assets/illustrations/welcome.svg?react';
import { IllustrationModalDialog } from '@/components/modals/IllustrationModalDialog';
import { IllustrationModalTitle } from '@/components/modals/IllustrationModalTitle';
import { ModalMainButtonGroup } from '@/components/modals/ModalMainButtonGroup';
import { useUserStore } from '@/stores/useUserStore';

export function WelcomeModal() {
  const open = useUserStore((state) => state.welcomeDialogOpen);
  const { setWelcomeDialogOpen } = useUserStore((state) => state.actions);

  const handleClose = () => setWelcomeDialogOpen(false);

  return (
    <Modal onClose={handleClose} open={open}>
      <IllustrationModalDialog sx={{ overflowY: 'auto' }}>
        <WelcomeIllustration style={{ marginLeft: 'auto', marginRight: 'auto' }} />
        <IllustrationModalTitle>
          Willkommen beim
          <br />
          RadMELDER
          <br />
          Baden-Württemberg!
        </IllustrationModalTitle>
        <Typography>
          Um unsere Ziele für Umwelt und Radverkehr zu erreichen braucht es, unter anderem, ein lückenloses Radwegenetz.
          <br />
          <br />
          Dazu müssen Radfahrende und Verwaltung zusammen wirken! Mit dem RadMELDER soll der Dialog dazu vereinfacht
          werden.
          <br />
          <br />
          Wir freuen uns auf Ihren Input!
        </Typography>

        <ModalMainButtonGroup>
          <Button onClick={handleClose} startDecorator={<AngleUpIcon style={{ transform: 'rotate(90deg)' }} />}>
            Start
          </Button>
        </ModalMainButtonGroup>
      </IllustrationModalDialog>
    </Modal>
  );
}
